import {HttpClient} from "@angular/common/http";
import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {forkJoin, Observable, of} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {Injectable} from "@angular/core";
import {SplashScreenService} from "./parts/splash-screen/splash-screen.service";
import UserService from '../api/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class InitialDataResolver implements Resolve<any> {
  constructor(
    private _httpClient: HttpClient,
    private splashScreenService: SplashScreenService,
    private router: Router,
    private userService: UserService
  ) {
  }

  private _loadUser() {
    return this.userService.loadUserInfo().pipe(
      catchError(err => {
        return of(null);
      })
    );
  }

  private _loadMercureKey() {
    return this.userService.loadUserInfo().pipe(
      catchError(err => {
        return of(null);
      })
    );
  }

  /**
   * Resolver
   *
   * @param route
   * @param state
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>
  {
    this.splashScreenService.setVisible(true);
    return forkJoin([
      this._loadUser()
    ])
      .pipe(
        catchError(error => {
            return of(null);
        }),
        map(data => {
          if(data[0] == null) {
            this.router.navigate(['auth', 'login']);
          } else {
            localStorage.setItem('mercure_key', data[0].mercureKey);
          }

          if(localStorage.getItem('deviceKey') == null) {
            localStorage.setItem('deviceKey', this.makeID(10));
          }

          this.splashScreenService.setVisible(false);
          return data;
        })
    );
  }

  private makeID(length) {
    let result           = '';
    const characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() *
        charactersLength));
    }
    return result;
  }
}
